import React, { Component } from "react";
import AthleteList from "./AthleteList";
import "./AthleteSearch.css";
import {
  Dropdown,
  Input,
  Icon,
  Pagination,
  Button,
  Popup,
} from "semantic-ui-react";
import SportList from "./SportList";
import PositionList from "./PositionList";
import AthleteGrid from "./AthleteGrid";
import AthleteDetailsList from "./AthleteDetailsList";
import ClassYearDropDown from "../layout/ClassYearDropDown";
import SchoolsToWatchPublic from "../layout/SchoolsWatch/SchoolsToWatchPublic";
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
export const debounce = (callback, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), delay);
  };
};

const filteredAcademicsOptions = [
  { key: 1, text: "ACT", value: 1 },
  { key: 2, text: "SAT", value: 2 },
];

const filteredPerPageOptions = [
  { key: 1, text: 10, value: 10 },
  { key: 2, text: 15, value: 15 },
  { key: 3, text: 20, value: 20 },
];
const filteredPerPageOptionsForList = [
  { key: 1, text: 10, value: 10 },
  { key: 2, text: 20, value: 20 },
  { key: 3, text: 30, value: 30 },
];
const filteredPerPageOptionsForGrid = [
  { key: 1, text: 6, value: 6 },
  { key: 2, text: 12, value: 12 },
  { key: 3, text: 24, value: 24 },
];

const initialState = {
  filteredGradClass: 0,
  filteredSport: null,
  filteredPosition: "",
  filteredAcademics: "None",
  search: "",
  key: Date.now(),
  searchEnabled: true,
  showCommitted: false,
  filteredPerPageOptions: 10,
  filteredPerPageOptionsForList: 10,
  filteredPerPageOptionsForGrid: 6,
  activePage: 1,
  totalPages: 1,
  grid: false,
  list: false,
  default: true,
  debounceSearch: "",
};

var searchIcon = null;

class AthleteSearch extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;

    searchIcon = "search";

    if (this.props.match.path === "/commitments") {
      this.state.showCommitted = true;
    } else {
      this.state.showCommitted = false;
    }

    this.updateTotalPage = this.updateTotalPage.bind(this);
    this.pageChange = this.pageChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.path !== this.props.match.path) {
      if (this.props.match.path === "/commitments") {
        this.setState({
          showCommitted: true,
        });
      } else {
        this.setState({
          showCommitted: false,
        });
      }
    }
  }

  handleClick = () => {
    this.setState(
      {
        search: "",
        debounceSearch: "",
      },
      () => {
        this.updateKey();
        searchIcon = "search";
      }
    );
  };

  debounceLog = debounce((query) => {
    this.setState({
      debounceSearch: query,
    });
  }, 500);
  handleOnChange = (e, data) => {
    switch (data.name) {
      case "filteredClass":
        this.setState({
          filteredGradClass: data.value,
        });
        this.updateKey();
        break;
      case "filteredSport":
        this.updateKey();
        switch (data.value) {
          case data.value:
            if (data.value === "") {
              this.setState({
                filteredSport: null,
                filteredPosition: "",
              });
            } else {
              this.setState({
                filteredSport: data.value,
              });
            }
            break;
          default:
            this.setState({
              filteredSport: null,
            });
        }
        break;
      case "filteredAcademics":
        this.updateKey();

        switch (data.value) {
          case 1:
            this.setState({
              filteredAcademics: "ACT",
            });
            break;
          case 2:
            this.setState({
              filteredAcademics: "SAT",
            });
            break;
          default:
            this.setState({
              filteredAcademics: "None",
            });
        }
        break;
      case "filteredSearch":
        this.debounceLog(e.target.value);
        this.setState(
          {
            search: e.target.value,
          },
          () => {
            if (this.state.search === "") {
              searchIcon = "search";
              this.updateKey();
            } else {
              searchIcon = (
                <Icon name="close" link onClick={this.handleClick} />
              );
            }
          }
        );
        break;
      case "filteredPerPageOptions":
        if (this.state.default) {
          this.setState(
            {
              filteredPerPageOptions: data.value,
              search: this.state.search,
            },
            () => {
              this.updateKey();
            }
          );
        }
        if (this.state.list) {
          this.setState(
            {
              filteredPerPageOptionsForList: data.value,
              search: this.state.search,
            },
            () => {
              this.updateKey();
            }
          );
        }
        if (this.state.grid) {
          this.setState(
            {
              filteredPerPageOptionsForGrid: data.value,
              search: this.state.search,
            },
            () => {
              this.updateKey();
            }
          );
        }

        break;
      default:
        this.updateKey();

        switch (data.value) {
          case data.value:
            if (data.value === "") {
              this.setState({
                filteredPosition: "",
              });
            } else {
              this.setState({
                filteredPosition: data.value,
              });
            }
            break;
          default:
            this.setState({
              filteredPosition: "",
            });
        }
    }
  };

  updateKey = () => {
    this.setState({ key: Date.now() });
  };

  pageChange = (event, data) => {
    this.setState({ activePage: data.activePage });
  };

  updateTotalPage = (number) => {
    this.setState({ totalPages: Math.ceil(number) });
  };

  render() {
    var pageTitle = null;

    if (this.state.showCommitted) {
      pageTitle = <h1>Commitments</h1>;
    } else {
      pageTitle = <h1>Athletes</h1>;
    }

    return (
      <>
        <div className="AthleteSearchContainer">
          <div className="AthleteDetailsBannerBar"></div>
          <div
            className={`AthleteSearchBanner ${
              this.state.showCommitted &&
              this.props.stw &&
              this.props.stw.length > 0
                ? "Commitmentsbanner"
                : ""
            } `}
          >
            {pageTitle}
            {this.state.showCommitted &&
              this.props.stw &&
              this.props.stw.length > 0 && (
                <div className="HomeSkillContainer commitments">
                  <SchoolsToWatchPublic />
                </div>
              )}
            <div className="AthleteSearchFilterContainer">
              <Input
                key={this.state.key}
                icon={searchIcon}
                placeholder="Search Athletes..."
                name="filteredSearch"
                onChange={this.handleOnChange}
                value={this.state.search}
              />
              <div className="AthleteSearchFilter">
                <SportList
                  onChange={this.handleOnChange}
                  placeholder="Sport"
                  name="filteredSport"
                  clearable
                />
                <ClassYearDropDown
                  admin={false}
                  commit={this.state.showCommitted ? true : false}
                  clearable
                  selection
                  fluid
                  placeholder="Class"
                  name="filteredClass"
                  onChange={this.handleOnChange}
                />
                <PositionList
                  placeholder="Position"
                  name="filteredPosition"
                  onChange={this.handleOnChange}
                  sport={this.state.filteredSport}
                  disabled={!this.state.filteredSport}
                  value={this.state.filteredPosition}
                />
                <Dropdown
                  clearable
                  options={filteredAcademicsOptions}
                  selection
                  fluid
                  placeholder="Academics"
                  name="filteredAcademics"
                  onChange={this.handleOnChange}
                />
              </div>
            </div>
          </div>
          <div className="list-btn-box">
            {this.state.default && <h5 className="gridBoxH5">Standard View</h5>}
            {this.state.list && <h5 className="gridBoxH5">List View</h5>}
            {this.state.grid && <h5 className="gridBoxH5">Grid View</h5>}
            <div className="gridBoxDiv">
              <Popup
                content="Standard View"
                trigger={
                  <Button
                    className={this.state.default ? "primary" : ""}
                    onClick={() => {
                      this.setState({
                        grid: false,
                        list: false,
                        default: true,
                      });
                    }}
                  >
                    <Icon name="server" />
                  </Button>
                }
              />
              <Popup
                content="List View"
                trigger={
                  <Button
                    className={this.state.list ? "primary" : ""}
                    onClick={() => {
                      this.setState({
                        list: true,
                        grid: false,
                        default: false,
                      });
                    }}
                  >
                    <Icon name="list ul" />
                  </Button>
                }
              />
              <Popup
                content="Grid View"
                trigger={
                  <Button
                    className={this.state.grid ? "primary" : ""}
                    onClick={() => {
                      this.setState({
                        grid: true,
                        list: false,
                        default: false,
                      });
                    }}
                  >
                    <Icon name="th" />
                  </Button>
                }
              />
            </div>
          </div>
          {this.state.default && (
            <div className="AthleteSearchDetail">
              <AthleteList
                updatePage={this.updateTotalPage}
                activePage={this.state.activePage}
                perPage={this.state.filteredPerPageOptions}
                filteredSearch={this.state.debounceSearch}
                filteredSport={this.state.filteredSport}
                filteredGradClass={this.state.filteredGradClass}
                filteredPosition={this.state.filteredPosition}
                filteredAcademics={this.state.filteredAcademics}
                showCommitted={this.state.showCommitted}
              />
            </div>
          )}
          {this.state.list && (
            <div className="AthleteSearchDetail with-grid">
              <AthleteDetailsList
                updatePage={this.updateTotalPage}
                activePage={this.state.activePage}
                perPage={this.state.filteredPerPageOptionsForList}
                filteredSearch={this.state.debounceSearch}
                filteredSport={this.state.filteredSport}
                filteredGradClass={this.state.filteredGradClass}
                filteredPosition={this.state.filteredPosition}
                filteredAcademics={this.state.filteredAcademics}
                showCommitted={this.state.showCommitted}
              />
            </div>
          )}
          {this.state.grid && (
            <div className="AthleteSearchDetail with-grid">
              <AthleteGrid
                updatePage={this.updateTotalPage}
                activePage={this.state.activePage}
                perPage={this.state.filteredPerPageOptionsForGrid}
                filteredSearch={this.state.debounceSearch}
                filteredSport={this.state.filteredSport}
                filteredGradClass={this.state.filteredGradClass}
                filteredPosition={this.state.filteredPosition}
                filteredAcademics={this.state.filteredAcademics}
                showCommitted={this.state.showCommitted}
              />
            </div>
          )}
          {/* pagination and pages show */}
          <div className="AthleteSearchDetail AthletePagination">
            <div className="AthleteSearchFilterDetail">
              <div className="AthleteSearchFilter filterResult">
                <span className="main">Show</span>

                <Dropdown
                  clearable
                  defaultValue={
                    this.state.default
                      ? filteredPerPageOptions[0].value
                      : this.state.list
                      ? filteredPerPageOptionsForList[0].value
                      : this.state.grid
                      ? filteredPerPageOptionsForGrid[0].value
                      : filteredPerPageOptions[0].value
                  }
                  options={
                    this.state.default
                      ? filteredPerPageOptions
                      : this.state.list
                      ? filteredPerPageOptionsForList
                      : this.state.grid
                      ? filteredPerPageOptionsForGrid
                      : filteredPerPageOptions
                  }
                  simple
                  item
                  selection
                  fluid
                  placeholder="Per Page"
                  name="filteredPerPageOptions"
                  onChange={this.handleOnChange}
                />

                <span className="main">Entries</span>
              </div>
            </div>
            <Pagination
              onPageChange={this.pageChange}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              pointing
              secondary
              totalPages={this.state.totalPages}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  let stw = [];
  const stwData = state.firestore.ordered.schoolstowatch;
  const schoolData = state.firestore.data.schools;

  if (
    stwData &&
    schoolData &&
    stwData.length > 0 &&
    Object.keys(schoolData).length > 0
  ) {
    stw = stwData.map((e) => {
      let data = null;
      if (e.school && schoolData[e.school]) {
        const school = schoolData[e.school];
        data = { ...e, schoolName: school.name };
      } else if (e.school && !schoolData[e.school]) {
        data = { ...e, schoolName: e.school };
      }
      return data;
    });
  }

  // advocateWikiOrder
  return {
    stw,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "schoolstowatch",
      orderBy: ["modifiedAt", "desc"],
    },
    {
      collection: "schools",
      orderBy: ["name", "asc"],
    },
  ])
)(AthleteSearch);
